import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Página no encontrada',
    body: 'Esa dirección no existe.',
    backLink: 'Volver a la vista general',
  },
  configWarning: {
    body: '<0>Configuración incompleta.</0> Falta {{missing}}. Configúralo en <1>.env.local</1> para el desarrollo local (ver <2>.env.example</2>), o en el entorno del contenedor para un despliegue.',
  },
  skipToContent: 'Saltar al contenido',
  brandName: 'NOLATR',
  mainNav: 'Principal',
  sectionNav: 'Sección',
  accountNav: 'Cuenta',
  openMainMenu: 'Abrir menú',
  closeMainMenu: 'Cerrar menú',
  activeCompany: 'Empresa activa',
  profileStub: {
    title: 'Perfil',
    lead: 'Tu página de perfil está en camino — por ahora esto es un marcador de posición para que el shell tenga a dónde enviarte.',
  },
  manageStub: {
    title: 'Gestionar',
    lead: 'Elige una sección del menú.',
  },
};
